import {Dictionary} from '../../types';
import {batchActions} from 'redux-batched-actions';
import {Dispatch} from 'redux';
import {AuditLog, auditLogStore} from "../entities/auditlog";
import {User, userStore} from "../entities/user";
import {getAuditLogs, getAuditLogsContainingId} from "../../api/auditLogApi";
import {Item, itemStore} from "../entities/inventory/item";

export interface AuditLogState {
  auditLogs: Dictionary<AuditLog>;
  users: Dictionary<User>;
  items: Dictionary<Item>;
}

export const loadAllAuditLogState = () => async (dispatch: Dispatch) => {
  const response: AuditLogState = await getAuditLogs();
  await dispatch(batchActions([
    dispatch(auditLogStore.actions.set(response.auditLogs)),
    dispatch(userStore.actions.set(response.users)),
    dispatch(itemStore.actions.setIncludedData(response.items))
  ], 'LOAD_AUDIT_LOG_STATE'));
};

export const loadEntityAuditLogState = (id: string) => async (dispatch: Dispatch) => {
  const response: AuditLogState = await getAuditLogsContainingId(id);
  await dispatch(batchActions([
    dispatch(auditLogStore.actions.setIncludedData(response.auditLogs)),
    dispatch(userStore.actions.set(response.users)),
    dispatch(itemStore.actions.setIncludedData(response.items))
  ], 'LOAD_AUDIT_LOG_STATE'));
};
